import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo, useContext } from 'react';
import { ModalContext } from './ModalContext.js';

var _templateObject;
var StyledModalOverlay = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.75);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  height: 100vh;\n  opacity: ", ";\n  padding-left: 1rem;\n  padding-right: 1rem;\n  position: fixed;\n  right: 0;\n  top: 0;\n  transition: opacity 0.3s, visibility 0.3s;\n  visibility: ", ";\n  width: 100vw;\n  z-index: 1001;\n"])), function (_ref) {
  var isOpen = _ref.isOpen;
  return !isOpen ? '0' : '1';
}, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return !isOpen ? 'hidden' : null;
});
var ModalOverlay = function ModalOverlay(_ref3) {
  var children = _ref3.children;
  var _useContext = useContext(ModalContext),
    isOpen = _useContext.isOpen,
    theme = _useContext.theme;
  return /*#__PURE__*/React.createElement(StyledModalOverlay, {
    theme: theme,
    isOpen: isOpen,
    "data-testid": 'modal-overlay'
  }, children);
};
var ModalOverlay$1 = /*#__PURE__*/memo(ModalOverlay);

export default ModalOverlay$1;
export { ModalOverlay };
